export default __webpack_public_path__ + "static/media/APPL.980f81be.png";